import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import App from './App.vue';
import './assets/css/public.css'
import './assets/css/static.css'
import "./assets/iconfont/iconfont.css";  // 阿里图标库

Vue.use(ElementUI);

// 字符串-日期截取
Vue.prototype.$stringSlice = function(value, start, end) {
  if(!value || value.length < 10) return ''
  return value.slice(start, end)
}

import {Base64} from 'js-base64'
Vue.prototype.$Base64 = Base64;

// window.addEventListener('popstate', function() {
//   history.pushState(null, null, document.URL)
// })

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
